"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const TemplateConstants_1 = require("./TemplateConstants");
const templateReducer = (state = TemplateConstants_1.TemplateInitialState, action) => {
    switch (action.type) {
        case TemplateConstants_1.TemplateActions.Open:
            {
                return Object.assign({}, state, {
                    businessId: action.payload.businessId,
                    callback: action.payload.callback
                });
            }
        case TemplateConstants_1.TemplateActions.Close:
            {
                return TemplateConstants_1.TemplateInitialState;
            }
        default:
            return state;
    }
};
exports.default = templateReducer;


//////////////////
// WEBPACK FOOTER
// ./client/src/shared/Template/TemplateReducer.ts
// module id = 783
// module chunks = 0 1 2